import React, { useState } from 'react'

import AppContext from './AppContext'
import CreateInvoice from './CreateInvoice'

const Invoice = () => {
  const [currency, setCurrency] = useState('₹')

  const currencySettings = {
    currency,
    setCurrency
  }

  return (
    <AppContext.Provider value={currencySettings}>
      <CreateInvoice />
    </AppContext.Provider>
  )
}

export default Invoice
